import type { CanvasGroup, GroupBounds } from '../types';
import { computeGroupBounds } from '../types';

/**
 * Build a map of group ID -> computed bounds for all groups.
 * Resolves child groups recursively before computing parent bounds.
 */
export function buildGroupBoundsMap(
  groups: CanvasGroup[],
  memberRectMap: Map<string, { x: number; y: number; width: number; height: number }>,
  layerHiddenNodeIds?: Set<string>,
): Map<string, GroupBounds> {
  const map = new Map<string, GroupBounds>();
  const visited = new Set<string>();

  function compute(groupId: string) {
    if (visited.has(groupId)) return;
    visited.add(groupId);
    const group = groups.find(g => g.id === groupId);
    if (!group) return;
    for (const childId of group.memberGroupIds) compute(childId);
    const bounds = computeGroupBounds(group, memberRectMap, map, undefined, layerHiddenNodeIds);
    if (bounds) map.set(groupId, bounds);
  }

  for (const g of groups) compute(g.id);
  return map;
}
